import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from '@wix/da-shared-react/pkg/Popup/ConfirmationModal';
import { PremiumTrash } from '@wix/da-ds/pkg/Icons/Confirmations/PremiumTrash';
import type { BIEventPayload } from '@wix/da-bi/pkg/types';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { useDispatch } from 'react-redux';

interface Props {
  biData?: BIEventPayload;
  removeAll: () => void;
  requestClose: () => void;
}

const DywRemoveConfirmationModal: React.FC<Props> = ({
  biData,
  removeAll,
  requestClose,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onConfirm = useCallback(() => {
    dispatch(removeAll());
    requestClose();
  }, [dispatch, removeAll, requestClose]);

  return (
    <ConfirmationModal
      isOpen
      withCancelButton
      title={t('watch.removeAll.modal.title')}
      text={t('watch.removeAll.modal.body')}
      cancelBtnLabel={t('watch.removeAll.modal.button.cancel')}
      cancelBtnBiData={{
        ...biData,
        evid: BiEventType.WATCH_CONFIRM_REMOVAL,
        removal_confirmed: 0,
      }}
      confirmBtnLabel={t('watch.removeAll.modal.button.remove')}
      confirmBtnBiData={{
        ...biData,
        evid: BiEventType.WATCH_CONFIRM_REMOVAL,
        removal_confirmed: 1,
      }}
      icon={<PremiumTrash />}
      onConfirm={onConfirm}
      onCancel={requestClose}
    />
  );
};
DywRemoveConfirmationModal.displayName = 'DywRemoveConfirmationModal';

export default DywRemoveConfirmationModal;
